import { CardCvcElement } from '@stripe/react-stripe-js'
import createInput from './utils'

const CardCVCInput = createInput(CardCvcElement)
export default CardCVCInput
